###
  Dynamic creative widget
###

class INTENT.widgets.TrdPartyCreative

  @CM_EDITOR_ID: "3rd-party-content"

  @ATTR_NAME: "data-widget-3rd-party-creative"

  @ATTR_FIELD_EMPTY_TYPE: "#{@ATTR_NAME}-empty-type"
  @ATTR_FIELD_CHANGE_TYPE: "#{@ATTR_NAME}-change-type"
  @ATTR_FIELD_EDITOR_TYPE: "#{@ATTR_NAME}-editor-type"

  @ATTR_FIELD_CONTENT_JS: "#{@ATTR_NAME}-content-js"
  @ATTR_FIELD_CONTENT_HTML: "#{@ATTR_NAME}-content-html"

  constructor: (@el) ->
    @s = @.constructor

    @empty_type = @el.find "[#{@s.ATTR_FIELD_EMPTY_TYPE}]"
    @change_type = @el.find "[#{@s.ATTR_FIELD_CHANGE_TYPE}]"
    @editor_type = @el.find "##{@s.CM_EDITOR_ID}"

    @content_js = @el.find "[#{@s.ATTR_FIELD_CONTENT_JS}]"
    @content_html = @el.find "[#{@s.ATTR_FIELD_CONTENT_HTML}]"

    @content_js_checkbox = @content_js.find ".on-off"
    @content_js_textarea = @content_js.find "textarea"
    @content_html_textarea = @content_html.find "textarea"

    @content_js_checkbox.on 'switchChange.bootstrapSwitch', @switch_type_content

    @change_type.on 'change', @update_cm_type

    $('.submit-button') .on 'click',  (e) =>
      errorTextValidateCreativeForm = INTENT.utils.CreativesValidation.validateForm()
      if errorTextValidateCreativeForm != ''
        INTENT.utils.Forms.disable_submit_buttons_loader()
        return
      @checkCreative(e)

  checkCreative: (e) =>
    self = @
    @btnSubmit = $(e.target)
    @form = @btnSubmit.parents('form#main_form')
    actionName = @btnSubmit.attr 'name'
    if not actionName
      actionName = 'update'

    value = @get_cm_instance().getValue()
    if value.indexOf('[[CLICK_PREFIX]]') == -1 && value.indexOf('[[CLICK_PREFIX_ENCODED]]') == -1 && value.indexOf('[[CLICK_TRACKING_BEACON]]') == -1
      show_confirm(
        __("creatives.click_macros_warn")
        ->
          self.form.append("<input type=\"hidden\" name=\"#{actionName}\" value=\"true\" />")
          self.form.submit()
        ->
          self.btnSubmit.hideLoader('disabled')
        __('btn.save')
        __('btn.cancel')
      )
      return false

    if $("#resizable:checked").length
      if value.indexOf('[[WIDTH]]') == -1 || value.indexOf('[[HEIGHT]]') == -1
        show_notification(
          __("creatives.no_resizable_macros")
          true
          'warning'
          ->
            self.btnSubmit.hideLoader('disabled')
        )
        return false

  update_cm_type: =>
    value = @change_type.val()
    editor = @get_cm_instance()

    label = @el.find "label[for='#{@s.CM_EDITOR_ID}']"

    if value == 'JS'
      type = 'javascript'
      unset_type = 'HTML'
    else
      type = 'htmlmixed'
      unset_type = 'JS'

    @editor_type.attr 'name', value
    @editor_type.attr 'placeholder', value

    @empty_type.attr 'name', unset_type

    if editor
      editor.setOption 'mode', type
      editor.setOption 'placeholder', value

    label.html value + '&nbsp;<span class="text-danger">*</span>'
    @editor_type.trigger 'change'

  get_cm_instance: =>
    get_cm_instance @s.CM_EDITOR_ID

  switch_type_content: (e, state) =>
    if state
      @content_js.removeClass('disabled')
      @content_html.addClass('disabled')

      @content_js_textarea.attr('disabled', false)
      @content_html_textarea.attr('disabled', true)
      @empty_type.attr 'name', 'HTML'
    else
      @content_js.addClass('disabled')
      @content_html.removeClass('disabled')

      @content_js_textarea.attr('disabled', true)
      @content_html_textarea.attr('disabled', false)
      @empty_type.attr 'name', 'JS'

    # removed editors
    codemirror_instances['3rd-party-content-js'].toTextArea()
    codemirror_instances['3rd-party-content-html'].toTextArea()

    # clear history and init editors
    codemirror_instances = {}
    init_codemirror()




